import { ELocale } from "@rentiohq/shared-frontend/dist/types/i18n.types";
import { IPaymentRequest } from "@rentiohq/shared-frontend/dist/types/paymentRequest.types";
import {
  isSameDay,
  TDate,
  format as dateFormat,
} from "@rentiohq/shared-frontend/dist/utils/date-fns.utils";
import { getLocale } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
// eslint-disable-next-line no-restricted-imports
import { enUS, fr, nl } from "date-fns/locale";

export const dateLocales: any = {
  [ELocale.NL]: nl,
  [ELocale.FR]: fr,
  [ELocale.EN]: enUS,
  // TODO: Remove
  en_US: enUS,
  en_GB: enUS,
};

export const format = (date: TDate, formatStr: string = "dd/MM/yyyy") =>
  date === undefined
    ? ""
    : dateFormat(date, formatStr, {
        locale: dateLocales[getLocale() || nl],
      });

export const getPeriod = (
  paymentRequest: IPaymentRequest,
  dateFormat?: string,
) => {
  const { dueDateAt, startedAt, endedAt } = paymentRequest;

  const dueDateAtFormatted = format(dueDateAt, dateFormat);

  if (!startedAt) {
    return dueDateAtFormatted;
  }

  if (isSameDay(startedAt, endedAt)) {
    return dueDateAtFormatted;
  }

  const startDateFormatted = format(startedAt, dateFormat);
  const endDateFormatted = format(endedAt, dateFormat);

  return `${startDateFormatted} - ${endDateFormatted}`;
};
